export const GET_CLIENT = "GET_CLIENT";
export const ADD_CLIENT = "ADD_CLIENT";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const DELETE_CLIENT = "DELETE_CLIENT";
export const GET_CLIENT_DETAILS = "GET_CLIENT_DETAILS";
